import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators, AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { CommonService } from 'app/_services/common.service'


@Component({
  selector: 'app-y-children',
  templateUrl: './y-children.component.html',
  styleUrls: ['./y-children.component.css']
})
export class YChildrenComponent implements OnInit {

  yChildrenForm = this
  .formBuilder
  .group({
    noOfChildren: [
      '', Validators.required
    ],
    childAge1: [
      '', 
    ],
    childAge2: [
      '', 
    ],
    childAge3: [
      '',
    ],
   
  });

  public ychildren;
  public noOfChildren;
  public yChild;
  public nChild;


  constructor(
    public dialogRef: MatDialogRef<YChildrenComponent>,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService : CommonService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any


    ) {
      this.ychildren = data;
     }

  ngOnInit(): void {

    this.ychildren =  JSON.parse(localStorage.getItem('young_children'));

    if(this.ychildren != null && this.ychildren != undefined){
      this.yChildrenForm.setValue({
        noOfChildren : this.ychildren.noOfChildren,
        // childAge1  : this.ychildren.childAge1, 
        // childAge2  : this.ychildren.childAge2,
        // childAge3  : this.ychildren.childAge3
      });
    }
    else{

    }

    if(this.ychildren == "veteran"){
      this.noOfChildren = true
  
      if(this.noOfChildren === 1){
      this.yChild = "true";
    } 
    else if( this.noOfChildren === 0){
      this.nChild = "true";

    }
    else {
      this.nChild = "false";
      this.yChild = "false";
    }
    }
  

    }
  

  onSubmit(){

    if(this.noOfChildren != "" ){

        this.yChildrenForm.value.noOfChildren = this.noOfChildren;
        this.yChildrenForm.value.childAge2 = "0";
        this.yChildrenForm.value.childAge3 = "0";
        this.yChildrenForm.value.childAge1 = "0";
        localStorage.setItem('young_children', JSON.stringify(this.yChildrenForm.value))
        this.dialogRef.close({
          event: 'yChildren',
          // isUpdated: true
        })
      }
      else{
        alert("Please fill all the details")
      }
   
  }

  
  navigateFromLogin() {
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if (isLoggedIn === "true") {
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login");
      this.router.navigate(['/login'])

    }
  }

  navigateMenu(){
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }
}
